import type { ReactNode } from "react";
import { DriveLogo } from "@/components/shared/DriveLogo";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

export function PublicLayout({
  children,
  contentClassName,
  align = "center",
}: {
  children: ReactNode;
  contentClassName?: string;
  align?: "center" | "start";
}) {

  return (
    <div className="min-h-screen bg-muted/30">
      <a href="#main-content" className="skip-content-link">メインコンテンツへスキップ</a>
      <header className="h-14 border-b bg-background">
        <div className="flex h-full w-full items-center px-4">
          <Link
            to="/login"
            className="inline-flex items-center gap-2 rounded-sm text-sm font-semibold text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
          >
            <DriveLogo />
          </Link>
        </div>
      </header>
      <main
        id="main-content"
        tabIndex={-1}
        className={cn(
          "mx-auto flex min-h-[calc(100vh-3.5rem)] w-full px-6 focus:outline-none",
          align === "center" ? "py-10" : "py-6",
          align === "center" ? "items-center justify-center" : "items-start",
          contentClassName ?? "max-w-lg",
        )}
      >
        {children}
      </main>
    </div>
  );
}
